import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { ReactMultiSelect } from "../../components/form-fields";
import { useHistory } from "react-router";
import { fetchProduct } from "../../redux/actions/product-action-types";

const FormSchema = Yup.object({
  categoryId: Yup.string()
    .trim()
    .required("Category Id is required"),
  subCategoryId: Yup.string()
    .trim()
    .required("Sub category Id is required"),
});

function PostNewListing() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [initialValues, setInitialValues] = useState({
    categoryId: "",
    subCategoryId: "",
  });

  const [subcategory, setSubCategory] = useState("");

  const categories = useSelector((state) => state.category?.categories);
  const subCategories = useSelector((state) => state.subCategory.subCategories);

  const categoryOptions = categories.map((category) => {
    return {
      key: category.id,
      label: category.title,
      value: category.id,
    };
  });

  const subCategoryOptions = subCategories.map((category) => {
    return {
      key: category.id,
      label: category.title,
      value: category.id,
      parentCategoryId: category.parentCategoryId
    };
  });

  const onCategoryChange = (e) => {
    setInitialValues({ ...initialValues, categoryId: e.value });
    setSubCategory(null);
  };

  const onSubCategoryChange = (e) => {
    setInitialValues({ ...initialValues, subCategoryId: e.value });
    setSubCategory(subCategoryOptions.find((option) => {
      return option.value === e.value;
    }));
  };

  const onSubmit = (values) => {
    
    let subCategory = subCategories.filter((cat) => {
      return cat.id === values.subCategoryId;
    });

    let category = categories.filter((cat) => {
      return cat.id === values.categoryId;
    });
    if(id){
      history.push(`/add-new-product/${id}`, {
        ...values,
        categoryName: category[0].title,
        subCategoryName: subCategory[0].title,
      });
    }else{
      history.push(`/add-new-product`, {
        ...values,
        categoryName: category[0].title,
        subCategoryName: subCategory[0].title,
      });
    }
    
  };

  useEffect(() => {
    if(id){
      dispatch(
        fetchProduct({
          id,
          callback: (data) => {
            setInitialValues({
              categoryId: data.categoryId,
              subCategoryId: data.subCategoryId,
            });
            setSubCategory(subCategoryOptions.find((option) => {
              return option.value === data.subCategoryId;
            }));
          },
        })
      );
    }
  }, [dispatch, id]);


  return (
    <div className="mainContentWrapper new-posting">
      <div className="row dashContentHeader px-5 mb-3">
        <h5 className="w-100 dashHeading mb-0">Add New Product</h5>
        <p className="w-100 text-lt mt-2 font-16">
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry.{" "}
        </p>
      </div>
      <div className="row dashboardCardRow px-5">
        <div className="col-lg-6 bg-white mt-5 shadow">
          <Formik
            initialValues={initialValues}
            validationSchema={FormSchema}
            onSubmit={onSubmit}
            enableReinitialize
          >
            {({ errors, values }) => (
              <Form className="mg-login new-product mt-4 px-3">
                <div className="row mb-0">
                  <div className="col-md-12 mb-4 ">
                    <ReactMultiSelect
                      label="CHOOSE A CATEGORY"
                      options={categoryOptions}
                      handleChange={onCategoryChange}
                      name="categoryId"
                      id="categoryId"
                      value={categoryOptions.find((option) => {
                        return option.value === values.categoryId;
                      })}
                      placeholder="CATEGORY"
                      className="form-control form-select"
                      errors={errors}
                      isRequired
                    />
                  </div>
                  <div className="col-md-12 mb-4">
                    <ReactMultiSelect
                      label="CHOOSE A SUB CATEGORY"
                      options={subCategoryOptions.filter((data)=>{
                        return data.parentCategoryId === initialValues.categoryId
                      })}
                      handleChange={onSubCategoryChange}
                      name="categoryId"
                      id="categoryId"
                      value={subcategory}
                      placeholder="SUB CATEGORY"
                      className="form-control form-select"
                      errors={errors}
                      isRequired
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end mb-5">
                  {/* <Link
                href={{
                  pathname: "/newproduct",
                  query: { category: category },
                }}
                as="/newproduct"
              > */}
                  <button type="submit" className="mb-5 sub-button mt-2">
                    Next Step
                  </button>
                  {/* </Link> */}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default PostNewListing;
